import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonCompComponent } from './common-comp.component';
import { MatAutocompleteModule, MatProgressBarModule } from '@angular/material';
import { NgMatAutocompleteModule } from '../autocomplete/autocomplete.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [CommonCompComponent]
})
export class CommonCompModule { }
